var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlossaryEmptyStateBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 300,
    viewBox: "0 0 500 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M69.5 77L107.172 98.75V142.25L69.5 164L31.8279 142.25V98.75L69.5 77Z",
    fill: "#CCD8E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.5 0L379.837 75.25V225.75L249.5 301L119.163 225.75V75.25L249.5 0Z",
    fill: "#E5ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M435 0L501.684 38.5V115.5L435 154L368.316 115.5V38.5L435 0Z",
    fill: "#E5ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M128 146L194.684 184.5V261.5L128 300L61.316 261.5V184.5L128 146Z",
    fill: "#E5ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M337.5 154L391.627 185.25V247.75L337.5 279L283.373 247.75V185.25L337.5 154Z",
    fill: "#E5ECF0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M89 29L109.785 41V65L89 77L68.2154 65V41L89 29Z",
    fill: "#E5ECF0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 300,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlossaryEmptyStateBackground);
export default __webpack_public_path__ + "static/media/GlossaryEmptyStateBackground.68fd9be6dc1bea4119a3fd9b9583a209.svg";
export { ForwardRef as ReactComponent };